import {
  DollarSign,
  Eye,
  MousePointer,
  TrendingUp,
  ShoppingBag,
  CircleDollarSign,
  Users as UsersIcon,
  Layers,
} from 'lucide-react';
import { KpiTile, KpiSkeleton } from '../../_shared/KpiTile';
import { useAccountSummary } from '../hooks/useAccountSummary';
import { CURRENCY, COMPACT, COMPACT_NUMBER, NUMBER, PERCENT, RATIO_X } from '../../_shared/format';

export function AccountKpiStrip() {
  const { data, loading } = useAccountSummary();

  if (loading || !data) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <KpiSkeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
      <KpiTile
        label="Total Spend"
        value={CURRENCY.format(data.total_spend)}
        icon={<DollarSign size={12} />}
        data-testid="kpi-tile-spend"
      />
      <KpiTile
        label="Impressions"
        value={COMPACT_NUMBER.format(data.total_impressions)}
        icon={<Eye size={12} />}
      />
      <KpiTile
        label="Clicks"
        value={NUMBER.format(data.total_clicks)}
        icon={<MousePointer size={12} />}
      />
      <KpiTile
        label="CTR"
        value={PERCENT(data.ctr)}
        icon={<TrendingUp size={12} />}
      />
      <KpiTile
        label="Purchases"
        value={NUMBER.format(data.total_purchases)}
        icon={<ShoppingBag size={12} />}
      />
      <KpiTile
        label="ROAS"
        value={RATIO_X(data.roas)}
        sub={`CPA ${CURRENCY.format(data.cpa)}`}
        icon={<CircleDollarSign size={12} />}
        tone={data.roas >= 1.5 ? 'success' : data.roas >= 0.5 ? 'default' : 'warning'}
      />
      <KpiTile
        label="Customers"
        value={COMPACT.format(data.total_customer_count).replace('$', '').trim() ||
          NUMBER.format(data.total_customer_count)}
        sub={`Avg LTV ${CURRENCY.format(data.avg_ltv)}`}
        icon={<UsersIcon size={12} />}
      />
      <KpiTile
        label="Active Ads"
        value={NUMBER.format(data.unique_ad_count)}
        icon={<Layers size={12} />}
      />
    </div>
  );
}
